import React from 'react';
import ReactDOM from 'react-dom';

import Price from './Classes/Price';
import ApiCalls from './Classes/ApiCalls';

import PackageFeatures from './Components/PackageFeatures';
import ContractSelection from './Components/ContractSelection';
import PowerpackList from './Components/PowerpackList';

class HostingSelection extends React.Component {
    constructor(props) {
        super(props);
		
		this.state = {
		  selectedPlatform: 'CPanel',
		  selectedPackage: _initialPackage,
		  featureList: [],
		  contractOptionList: [],
		  powerpackList: []
		}

		this._handleContractChanged = this._handleContractChanged.bind(this);
		this._handlePowerpackToggled = this._handlePowerpackToggled.bind(this);
		this._noPowerpackSelected = this._noPowerpackSelected.bind(this);
    }

	componentDidMount() {

		this._getFeatures(_initialPackage);

		this._getContracts(_initialPackage);

		this._getPowerpacks();

    }

	_getContracts(selectedPackage) {

		var apiResult = "";

		var _this = this;

		var url = "contracts/" + selectedPackage;
		
		ApiCalls.post(
			url, 
			'OK', 
			function(data) { 
				apiResult = JSON.parse(data).Data;
				_this._setContracts(apiResult);
				}
		);

	}

	_setContracts(apiResult) {
		
		var _this = this;
		var _newArray = []

		for (var i = 0; i < apiResult.Prices.length; i++) {

			var priceValue = apiResult.Prices[i].Price.Value;
			var selected = false;

			if (apiResult.Prices[i].ContractLength == 1) //THIS IS THE DEFAULT - SHOULD MATCH THE DEFAULT USED IN THE CS FILES. 
			{
				selected = true;
			}

			_newArray.push({Key: i, Name: apiResult.Prices[i].ContractLength + ' month', Price: new Price(priceValue, 'month'), Offer: '', Selected: selected});
		}

		_this.setState ({ contractOptionList: _newArray });

		_this._updateSelection();

	}

	_getFeatures(selectedPackage) {

		var apiResult = "";

		var _this = this;

		var url = "features/" + selectedPackage;
		
		ApiCalls.post(
			url, 
			'OK', 
			function(data) { 
				apiResult = JSON.parse(data).Data;
				_this._setFeatures(apiResult);
				}
		);

	}

	_setFeatures(apiResult) {
		
		var _this = this;
		var _newArray = [];

		for (var i = 0; i < apiResult.length; i++) 
		{
			_newArray.push(apiResult[i]);
		}

		_this.setState ({ featureList: _newArray});

		_this._updateSelection();

	}

	_getPowerpacks() {

		var apiResult = "";

		var _this = this;

		var url = "powerpacks";
		
		ApiCalls.post(
			url, 
			'OK', 
			function(data) { 
				apiResult = JSON.parse(data).Data;
				_this._setPowerpacks(apiResult);
				}
		);

	}

	_setPowerpacks(apiResult) {
		
		var _this = this;
		var _newArray = [];

		for (var i = 0; i < apiResult.length; i++) 
		{
			_newArray.push(
				{
					PowerpackType: apiResult[i].PowerpackType,
					Name: 'Powerpack ' + apiResult[i].PowerpackType, 
					Description: apiResult[i].Description, 
					CPUs: apiResult[i].Cpus, 
					Ram: apiResult[i].Ram, 
					Price: new Price(apiResult[i].Price.Value, 'month'), 
					Selected: false });
		}

		_this.setState ({ powerpackList: _newArray});

		_this._updateSelection();
	}
	
	_handleContractChanged(contractOption) {

		var _this = this;
		var newArray = this.state.contractOptionList.slice();

		for (var i = 0; i < newArray.length; i++) {
			newArray[i].Selected = false;
			if (newArray[i].Key == contractOption.Key) { 
				newArray[i].Selected = true; 
			}
		}

		_this.setState({ contractOptionList: newArray });

		_this._updateSelection();
	}

	_noPowerpackSelected(){
		var _this = this;
		var newArray = this.state.powerpackList.slice();
		for (var i = 0; i < newArray.length; i++) {
			newArray[i].Selected = false; 
		}

		_this.setState({ powerpackList: newArray });

		_this._updateSelection();
	}

	_handlePowerpackToggled(powerpack) {

		var _this = this;

		var newArray = this.state.powerpackList.slice();

		if(powerpack != undefined){
			for (var i = 0; i < newArray.length; i++) {
				if (newArray[i].Name == powerpack.Name) 
				{ 
					newArray[i].Selected = !powerpack.Selected; 
				}
				else
				{
					newArray[i].Selected = false; 
				}
			}

			_this.setState({ powerpackList: newArray });

			_this._updateSelection();
		}
	}

	_updateSelection() {

		console.log("Updating selection");
   
		var _this = this;

		var _renewalPeriod = '';
		var _selectedPowerpack = 'None';

		for (var i = 0; i < _this.state.contractOptionList.length; i++) {
			if (_this.state.contractOptionList[i].Selected) 
			{ 
				var _seletedcontract = _this.state.contractOptionList[i].Name;

				if (_seletedcontract === "1 month")
				{
					_renewalPeriod = "Monthly"
				}

				if (_seletedcontract === "12 month")
				{
					_renewalPeriod = "Annual"
				}
			}
		}

		for (var i = 0; i < _this.state.powerpackList.length; i++) {
			if (_this.state.powerpackList[i].Selected) 
			{ 
				_selectedPowerpack = _this.state.powerpackList[i].Name;
			}
		}

		var _newArray = {
			hostingType: _this.state.selectedPlatform,
			packageType: _this.state.selectedPackage,
			contractLength: _renewalPeriod,
			powerpack: _selectedPowerpack,
			domainName: ""
			}

		window.selectionUpdated(_newArray);

	}

	_round(value, exp) {

		if (typeof exp === 'undefined' || +exp === 0)
		return Math.round(value);

		value = +value;
		exp = +exp;

		if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
		return NaN;

		// Shift
		value = value.toString().split('e');
		value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

		// Shift back
		value = value.toString().split('e');
		return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
	}
    
	_features(features){
		var features = features.state.featureList.map(item => <li key={item} className="small-spacing col-lg-6 col-md-6 col-sm-4">{item}</li>)
		var showFeatures = features != undefined && features.length > 0 ? '' : 'd-none';
		var showLoading = features == undefined || features.length < 1 ? '' : 'd-none';

		return(
			<div>
				<div className={showLoading}>
					<div className="text-container">
						<p>Gathering package features 
							<img className="spinner" src="/content/images/loading.gif" 
								height="30" width="30" alt="Gathering package features" />
						</p>
					</div>
				</div>

				<div className={showFeatures}>
					<h6>PACKAGE INCLUDES</h6>
					<ol className="list-unstyled row">
						{features}
					</ol>
				</div>
			</div>
		)
	}

	render() {

		var a = this;

		var price = Price.nullPrice().asObject();		

		var newArray = a.state.contractOptionList.slice();

		for (var i = 0; i < newArray.length; i++) {
			if (newArray[i].Selected) {
				price = newArray[i].Price;
			}
		}					

		var hidePowerpacks = (_initialPackage == "Reseller");

		return (
			<div className="hosting-package" id="hostingSelection">
				<div className="card-header primary-header z-pal-bg-primary z-pal-txt-primsup-2">
					<div className="row">
						<div className="col-sm-8 col-md-7">
							<h2>{_initialPackage} CPanel Hosting</h2>
						</div>

						<div className="col-sm-4 col-md-5 text-left text-md-right text-sm-right">
							<div id="HeadlinePrice" className="panel-header-price text-md-right col-12">&pound;{price.price}</div>
							<div className="panel-header-price-info text-md-right col-12">/month</div>
						</div>
					</div>
				</div>

				<div className="card-body">
					<div className="featureSet">
						<div className="text-container">
							{a._features(a)}
						</div>
					</div>
				</div>
                    
				{
					!hidePowerpacks  &&
					<div>
						<hr className="z-pal-border-primary-faded" />

						<div className="card-body">
							<div className="section-container text-container">
								<ContractSelection key={a.state.selectedPackage}
								contractOptionList={a.state.contractOptionList}
								onContractSelectionChanged={contractOption => a._handleContractChanged(contractOption)}
								/>
							</div>
						</div>
					</div>
				}

                <hr className="z-pal-border-primary-faded" />

				<div className="card-body">
					<PowerpackList 
						powerpacks={this.state.powerpackList} 
						hide={hidePowerpacks} 
						onPowerpackSelectionToggled={powerpack => a._handlePowerpackToggled(powerpack)}
						noPowerpackSelected={powerpack => a._noPowerpackSelected()}
					/>
                </div>
			</div>
		)
	}
}

ReactDOM.render(
    <HostingSelection/>,
    document.getElementById("HostingSelectionReact"));





// WEBPACK FOOTER //
// ./Scripts/App/Hosting/HostingSelection.es6